import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import 'antd/dist/antd.css';
import Landing from "./pages/Landing";
import DashboardLayout from "./components/Layout/index";

import { useWeb3React } from "@web3-react/core";
import { connectors } from "./utils/connectors";

const App = () => {

    const {
        library,
        chainId,
        account,
        activate,
        deactivate,
        active
    } = useWeb3React();
    
    const [signature, setSignature] = useState("");
    const [error, setError] = useState("");
    const [network, setNetwork] = useState(undefined);
    const [message, setMessage] = useState("");
    const [signedMessage, setSignedMessage] = useState("");
    const [verified, setVerified] = useState();

    const refreshState = () => {
        window.localStorage.setItem("provider", undefined);
        setNetwork("");
        setMessage("");
        setSignature("");
        setVerified(undefined);
    };

    const disconnect = () => {
        refreshState();
        deactivate();
    };

    useEffect(() => {
        const provider = window.localStorage.getItem("provider");       
        activate(connectors[provider]);      
    }, []);


    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <Landing />
                </Route>
                <DashboardLayout  disconnect={() => disconnect()} />
                {/* {
                    userRoutes.map((route, idx) => (
                        <DashboardLayoutRoute
                            path={route.path}
                            component={route.component}
                            key={idx}
                            // isAuthProtected={true}
                            exact
                            disconnect={() => disconnect()}
                        />
                    ))
                } */}
            </Switch>
        </Router>
    );
}

export default App;
